import { useFilterRewardEventContext } from "./filter-reward-event.context";

export function FilterRewardEvent() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterRewardEventContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}